import { makeCancellableAPIRequest } from "./index";

const NotificationAPI = {
    createNotification(queryParams = {}){
        return makeCancellableAPIRequest(
            "POST",
            "/user/notification",
            {
                data: queryParams
            }
        )
    },
    getNotification(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/notification/tenant"
        )
    }
}

export default NotificationAPI;